import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux'
import { persistStore, persistReducer, createTransform } from 'redux-persist'
import { parse, stringify } from 'flatted'
import storage from 'redux-persist/lib/storage'
import thunk from 'redux-thunk'

// Reducers
import auth from '../reducers/auth'
import lookupData from '../reducers/lookupData'
import application from '../reducers/application'
import release from '../reducers/release'
import publish from '../reducers/publish'

// Combining reducers
const reducers = combineReducers({
  auth,
  lookupData,
  application,
  release,
  publish
})

// Middlewares
const middlewares = [thunk]

// Redux persist
export const JSONTransform = createTransform(
  inboundState => stringify(inboundState),
  outboundState => parse(outboundState),
)
const persistConfig = {
  key: 'SoftrigManagmentUI',
  storage,
  transforms: [JSONTransform],
  blacklist: []
}
const persistedReducers = persistReducer(persistConfig, reducers)

// Create store method
const createStore = () => {
  const store = reduxCreateStore(persistedReducers, applyMiddleware(...middlewares))
  const persistor = persistStore(store)
  return { store, persistor }
}

export default createStore